enum BackendType {
  OPTAIN = 'optain',
  GALENDATA = 'galendata',
}

export { BackendType };
